import * as React from "react"

import { FlowInputCallback, FlowInputTextType, FlowQuestionId } from "types"
import * as styles from "./styles.module.scss"
import InputText from "../InputText"

export interface InputPercentageProps {
  disabled?: boolean
  flowKey: FlowQuestionId
  onSubmit: FlowInputCallback
  userAnswer: any
}

const InputPercentage: React.FC<InputPercentageProps> = ({
  disabled,
  flowKey,
  onSubmit,
  userAnswer,
}) => {
  const onSubmitFormat = ({
    flowKey,
    value,
  }: {
    flowKey: FlowQuestionId
    value: string
  }) => {
    const formattedValue = `${value}%`

    onSubmit({
      flowKey,
      value,
      display: formattedValue,
    })
  }

  return (
    <InputText
      flowKey={flowKey}
      className={styles.rate}
      inputType={FlowInputTextType.Percentage}
      maxLength={5}
      min={0}
      step={0.001}
      suffixSign="%"
      onSubmit={onSubmitFormat}
      disabled={disabled}
      userAnswer={userAnswer}
    />
  )
}

export default InputPercentage
